import React from 'react';

export default function EmptyState({ emoji = '✨', title, subtitle, action }) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.emoji} aria-hidden>{emoji}</div>
      {title && <h3 style={styles.title}>{title}</h3>}
      {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      {action && <div style={styles.action}>{action}</div>}
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '40px 24px',
    gap: 8,
  },
  emoji: {
    fontSize: 44,
    marginBottom: 4,
    lineHeight: 1,
  },
  title: {
    margin: 0,
    fontSize: 17,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  subtitle: {
    margin: 0,
    fontSize: 14,
    color: '#6B6B6B',
    maxWidth: 280,
    lineHeight: 1.5,
  },
  action: {
    marginTop: 12,
  },
};
